import { render, staticRenderFns } from "./EmployeeWelfare.vue?vue&type=template&id=44339a9a&scoped=true&"
import script from "./EmployeeWelfare.vue?vue&type=script&lang=js&"
export * from "./EmployeeWelfare.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWelfare.vue?vue&type=style&index=0&id=44339a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44339a9a",
  null
  
)

export default component.exports